export default {"src":"/_next/static/media/full-grey-bg.0fca8524.svg","height":747,"width":1440};